module.exports = __webpack_public_path__ + "static/media/logo.46825a4a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/images/logo.jpg
 ** module id = 860
 ** module chunks = 0
 **/